import {createSelector} from 'reselect';
import {
  namesIconSelector,
  numbersIconSelector
} from '~/selectors/CanvasSelectors';

export function getNamesAndNumbers(state) {
  const records =
    state.namesAndNumbers.present?.toArray() || state.namesAndNumbers.toArray();
  return records;
}

export function getNamesAndNumbersJS(state) {
  const records = getNamesAndNumbers(state);
  return records.map(record => (record.toJS ? record.toJS() : record));
}

export const getEmptyNamesAndNumbers = createSelector(
  getNamesAndNumbers,
  namesAndNumbers => namesAndNumbers.filter(n => !n.name && !n.number)
);

export const getNonEmptyNamesAndNumbers = createSelector(
  getNamesAndNumbers,
  namesAndNumbers => namesAndNumbers.filter(n => n.name || n.number)
);

export const getNameCount = state => {
  const namesAndNumbers = getNamesAndNumbers(state);
  const namesIcon = namesIconSelector(state);
  const namesCount = namesAndNumbers.reduce(
    (count, item) => (item.name ? count + 1 : count),
    0
  );
  return namesIcon ? namesCount : 0;
};

export const getNumberCount = state => {
  const namesAndNumbers = getNamesAndNumbers(state);
  const numbersIcon = numbersIconSelector(state);
  const numbersCount = namesAndNumbers.reduce(
    (count, item) => (item.number ? count + 1 : count),
    0
  );
  return numbersIcon ? numbersCount : 0;
};

export const getNamesAndNumbersCount = state => {
  const namesAndNumbers = getNamesAndNumbers(state);
  return namesAndNumbers.reduce(
    (count, item) => (item.name || item.number ? count + 1 : count),
    0
  );
};

export const getNamesAndNumbersSizes = createSelector(
  getNamesAndNumbers,
  namesAndNumbers =>
    namesAndNumbers
      .filter(n => n.productSize)
      .map(x => x.productSize)
      .reduce((acc, size) => {
        size in acc ? acc[size]++ : (acc[size] = 1);
        return acc;
      }, {})
);

export const getEmptyNamesAndNumbersSizes = createSelector(
  getEmptyNamesAndNumbers,
  namesAndNumbers =>
    namesAndNumbers
      .filter(n => !!n.productSize)
      .map(n => n.productSize)
      .reduce((acc, size) => {
        size in acc ? acc[size]++ : (acc[size] = 1);
        return acc;
      }, {})
);

export const getNonEmptyNamesAndNumbersSizes = createSelector(
  getNonEmptyNamesAndNumbers,
  namesAndNumbers =>
    namesAndNumbers
      .filter(n => !!n.productSize)
      .map(n => n.productSize)
      .reduce((acc, size) => {
        size in acc ? acc[size]++ : (acc[size] = 1);
        return acc;
      }, {})
);
